﻿export const MandatoryDataMissing = "Mandatory data missing";
export const IncorrectFormat = "Incorrect format";
export const IncorrectData = "Incorrect data";
export const ValueTooLong = "Value too long";
export const ValueTooShort = "Value too short";
export const InvalidEmail = "Incorrect email";
export const InvalidPhone="Incorrect phone"
